import React, { useState } from 'react';
import { Box, Container, Typography, Paper, TextField, Button, Snackbar, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from '@mui/material';
import { useAvatar } from '../contexts/AvatarContext';

const Settings = () => {
  const [userName, setUserName] = useState(() => {
    return localStorage.getItem('advisorName') || '王曉明';
  });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [inputValue, setInputValue] = useState(() => {
    return localStorage.getItem('advisorName') || '王曉明';
  });
  const [gender, setGender] = useState(() => {
    return localStorage.getItem('advisorGender') || 'male';
  });
  const [avatarStyle, setAvatarStyle] = useState(() => {
    return localStorage.getItem('avatarStyle') || 'avataaars';
  });
  const [avatarBgColor, setAvatarBgColor] = useState(() => {
    return localStorage.getItem('avatarBgColor') || 'b6e3f4';
  });
  const [avatarSeed, setAvatarSeed] = useState(() => {
    return localStorage.getItem('avatarSeed') || Math.floor(Math.random() * 10000).toString();
  });
  const { updateAvatarSettings } = useAvatar();

  const handleNameChange = (event) => {
    setInputValue(event.target.value);
  };

  const generateRandomSeed = () => {
    const newSeed = Math.floor(Math.random() * 10000).toString();
    setAvatarSeed(newSeed);
  };

  const handleSave = () => {
    setUserName(inputValue);
    localStorage.setItem('advisorName', inputValue);
    localStorage.setItem('advisorGender', gender);
    localStorage.setItem('avatarStyle', avatarStyle);
    localStorage.setItem('avatarBgColor', avatarBgColor);
    localStorage.setItem('avatarSeed', avatarSeed);
    updateAvatarSettings({
      style: avatarStyle,
      bgColor: avatarBgColor,
      seed: avatarSeed,
      name: inputValue,
    });
    setShowSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setShowSnackbar(false);
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
        設定
      </Typography>
      <Paper elevation={0} sx={{ p: 3, bgcolor: '#f5f5f5' }}>
        <Box sx={{ p: 2, bgcolor: 'white', borderRadius: 1 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            名字
          </Typography>
          <TextField
            fullWidth
            value={inputValue}
            onChange={handleNameChange}
            placeholder="請輸入名字"
            variant="outlined"
            sx={{ mt: 1, mb: 2 }}
          />
          <Box sx={{ mt: 4, mb: 2 }}>
            <FormControl component="fieldset">
              <FormLabel component="legend">性別</FormLabel>
              <RadioGroup
                row
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <FormControlLabel value="male" control={<Radio />} label="男性" />
                <FormControlLabel value="female" control={<Radio />} label="女性" />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ mt: 4, mb: 2 }}>
            <FormControl fullWidth>
              <FormLabel component="legend">頭像樣式</FormLabel>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                <Select
                  value={avatarStyle}
                  onChange={(e) => setAvatarStyle(e.target.value)}
                  size="small"
                  sx={{ minWidth: 200 }}
                >
                  <MenuItem value="adventurer">探險者</MenuItem>
                  <MenuItem value="adventurer-neutral">中立探險者</MenuItem>
                  <MenuItem value="avataaars">Avataaars</MenuItem>
                  <MenuItem value="avataaars-neutral">中立Avataaars</MenuItem>
                  <MenuItem value="big-ears">大耳朵</MenuItem>
                  <MenuItem value="big-ears-neutral">中立大耳朵</MenuItem>
                  <MenuItem value="big-smile">大笑容</MenuItem>
                  <MenuItem value="bottts">Bottts</MenuItem>
                  <MenuItem value="bottts-neutral">中立Bottts</MenuItem>
                  <MenuItem value="croodles">Croodles</MenuItem>
                  <MenuItem value="croodles-neutral">中立Croodles</MenuItem>
                  <MenuItem value="fun-emoji">有趣emoji</MenuItem>
                  <MenuItem value="icons">圖示</MenuItem>
                  <MenuItem value="identicon">Identicon</MenuItem>
                  <MenuItem value="initials">首字母</MenuItem>
                  <MenuItem value="lorelei">Lorelei</MenuItem>
                  <MenuItem value="lorelei-neutral">中立Lorelei</MenuItem>
                  <MenuItem value="micah">Micah</MenuItem>
                  <MenuItem value="miniavs">Miniavs</MenuItem>
                  <MenuItem value="notionists">Notionists</MenuItem>
                  <MenuItem value="notionists-neutral">中立Notionists</MenuItem>
                  <MenuItem value="open-peeps">開放人物</MenuItem>
                  <MenuItem value="personas">人物</MenuItem>
                  <MenuItem value="pixel-art">像素藝術</MenuItem>
                  <MenuItem value="pixel-art-neutral">中立像素藝術</MenuItem>
                  <MenuItem value="rings">環形</MenuItem>
                  <MenuItem value="shapes">形狀</MenuItem>
                  <MenuItem value="thumbs">拇指</MenuItem>
                </Select>
                <Button 
                  variant="outlined" 
                  onClick={generateRandomSeed}
                  size="small"
                >
                  隨機生成
                </Button>
                <Box sx={{ ml: 2 }}>
                  <img 
                    src={`https://api.dicebear.com/7.x/${avatarStyle}/svg?seed=${avatarStyle === 'initials' ? userName[0] : avatarSeed}&backgroundColor=${avatarBgColor}`}
                    alt="Avatar preview"
                    style={{ width: 60, height: 60, borderRadius: '50%' }}
                  />
                </Box>
              </Box>
            </FormControl>
          </Box>
          <Box sx={{ mt: 4, mb: 2 }}>
            <FormControl fullWidth>
              <FormLabel component="legend">頭像背景色</FormLabel>
              <Select
                value={avatarBgColor}
                onChange={(e) => setAvatarBgColor(e.target.value)}
                size="small"
                sx={{ mt: 1 }}
              >
                <MenuItem value="b6e3f4">藍色</MenuItem>
                <MenuItem value="ffdfbf">橘色</MenuItem>
                <MenuItem value="ffd1dc">粉色</MenuItem>
                <MenuItem value="c1f0c1">綠色</MenuItem>
                <MenuItem value="d4e7ff">淺藍</MenuItem>
                <MenuItem value="ffe5d9">淺橘</MenuItem>
                <MenuItem value="f0e6ff">淺紫</MenuItem>
                <MenuItem value="fff4e6">米色</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Button 
            variant="contained" 
            onClick={handleSave}
            fullWidth
            sx={{
              bgcolor: '#1976d2',
              '&:hover': {
                bgcolor: '#115293'
              }
            }}
          >
            儲存設定
          </Button>
          <Snackbar
            open={showSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            message="已儲存設定"
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default Settings;
